import * as types from './actionTypes';
import { fetchCurrentUserFromSession } from '@forwardfinancing/component-library';

export function receiveUserData(json) {
  const data = json.user || {};
  return {type: types.RECEIVE_USER_DATA, user: data};
}

export function clearUserData() {
  return {type: types.CLEAR_USER_DATA};
}

export function fetchUserData() {
  return dispatch => {
    return fetchCurrentUserFromSession().then(user => {
      return dispatch(receiveUserData({user}));
    });
  };
}

export function signOutUser() {
  return dispatch => {
    dispatch(clearUserData());
    return Promise.resolve();
  };
}
